import { Field } from "formik";
import { AccordionBody, AccordionHeader, AccordionItem } from "../../Accordion";
import RadioCard from "../../RadioCard";
import ValidatedField from "../../form/ValidatedField";
import {
  RevisorsSectionProps,
  scrollToRefIfNotInView,
} from "../RevisorsErklaering";

export default function RevisorsHandling2(props: RevisorsSectionProps) {
  const { isCompleteHelpers, formikProps, refs, texts, locked } = props;
  const { revisors_handling_2 } = texts;
  const { values, errors, touched } = formikProps;
  return (
    <AccordionItem value="Handling2">
      <AccordionHeader
        sectionStarted={!!values.revisors_handling_2_question}
        sectionComplete={isCompleteHelpers.revisors_handling_2_complete}
        ref={refs.handling_2_ref}
        onClick={() => {
          scrollToRefIfNotInView(refs.handling_1_ref);
        }}
      >
        {revisors_handling_2.title}
      </AccordionHeader>
      <AccordionBody>
        <fieldset disabled={locked}>
          <div className="h5 fw-normal mb-4 lh-base">
            {revisors_handling_2.description}
          </div>
          <div className="vstack gap-3" role="group">
            <RadioCard
              checkIconTop="6px"
              value={
                revisors_handling_2.revisors_handling_2_question
                  .revisors_handling_2_question_alt_1.id
              }
              name={revisors_handling_2.revisors_handling_2_question.id}
              id={
                revisors_handling_2.revisors_handling_2_question
                  .revisors_handling_2_question_alt_1.id
              }
              text={
                <>
                  <span className="row mb-2 align-items-center">
                    <span className="col-auto">
                      <label className="pe-none">
                        {
                          revisors_handling_2
                            .revisors_handling_2_alt_1_og_3_antal_bokonti_stikprover
                            .label
                        }
                      </label>
                    </span>
                    <span className="col-3 position-relative">
                      <ValidatedField
                        touched={
                          touched.revisors_handling_2_alt_1_og_3_antal_bokonti_stikprover
                        }
                        error={
                          errors.revisors_handling_2_alt_1_og_3_antal_bokonti_stikprover
                        }
                        additionalClasses="py-1"
                        name={
                          revisors_handling_2
                            .revisors_handling_2_alt_1_og_3_antal_bokonti_stikprover
                            .id
                        }
                        style={{ width: 100 }}
                        placeholder="0"
                      />
                    </span>
                  </span>
                  <span>
                    {
                      revisors_handling_2.revisors_handling_2_question
                        .revisors_handling_2_question_alt_1.label
                    }
                  </span>
                </>
              }
            />
            <RadioCard
              name={revisors_handling_2.revisors_handling_2_question.id}
              id={
                revisors_handling_2.revisors_handling_2_question
                  .revisors_handling_2_question_alt_2.id
              }
              value={
                revisors_handling_2.revisors_handling_2_question
                  .revisors_handling_2_question_alt_2.id
              }
              text={
                revisors_handling_2.revisors_handling_2_question
                  .revisors_handling_2_question_alt_2.label
              }
            ></RadioCard>
            <RadioCard
              checkIconTop="6px"
              name={revisors_handling_2.revisors_handling_2_question.id}
              id={
                revisors_handling_2.revisors_handling_2_question
                  .revisors_handling_2_question_alt_3.id
              }
              value={
                revisors_handling_2.revisors_handling_2_question
                  .revisors_handling_2_question_alt_3.id
              }
              text={
                <>
                  <span className="row align-items-center mb-3">
                    <span className="col-auto">
                      <label className="pe-none">
                        {
                          revisors_handling_2
                            .revisors_handling_2_alt_1_og_3_antal_bokonti_stikprover
                            .label
                        }
                      </label>
                    </span>
                    <span className="col-3 position-relative">
                      <ValidatedField
                        touched={
                          touched.revisors_handling_2_alt_1_og_3_antal_bokonti_stikprover
                        }
                        error={
                          errors.revisors_handling_2_alt_1_og_3_antal_bokonti_stikprover
                        }
                        additionalClasses="py-1"
                        name={
                          revisors_handling_2
                            .revisors_handling_2_alt_1_og_3_antal_bokonti_stikprover
                            .id
                        }
                        style={{ width: 100 }}
                        placeholder="0"
                      />
                    </span>
                  </span>
                  <div>
                    {
                      revisors_handling_2.revisors_handling_2_question
                        .revisors_handling_2_question_alt_3.labelBeforeNumber
                    }{" "}
                    <Field
                      className="form-control d-inline-block mx-1 py-1 px-2 text-center"
                      placeholder="0"
                      style={{ width: 100 }}
                      name={
                        revisors_handling_2.revisors_handling_2_question
                          .revisors_handling_2_question_alt_3.id
                      }
                      autoComplete="off"
                    />{" "}
                    {
                      revisors_handling_2.revisors_handling_2_question
                        .revisors_handling_2_question_alt_3.labelAfterNumber
                    }
                  </div>
                </>
              }
            >
              <div className="vstack gap-3 mt-2 col-12 col-xl-11">
                <div className="row align-items-center">
                  <div className="col-9">
                    <label>
                      {
                        revisors_handling_2
                          .revisors_handling_2_alt_3_antal_bokonti_ikke_opprettet_i_kurators_bobestyrers_advokatselskabets_navn
                          .label
                      }
                    </label>
                  </div>
                  <div className="col-3">
                    <Field
                      autoComplete="off"
                      className="form-control"
                      placeholder="0"
                      name={
                        revisors_handling_2
                          .revisors_handling_2_alt_3_antal_bokonti_ikke_opprettet_i_kurators_bobestyrers_advokatselskabets_navn
                          .id
                      }
                    />
                  </div>
                </div>
                <div className="row align-items-center">
                  <div className="col-9">
                    <label>
                      {
                        revisors_handling_2
                          .revisors_handling_2_alt_3_antal_bokonti_ikke_opprettet_i_boets_navn
                          .label
                      }
                    </label>
                  </div>
                  <div className="col-3">
                    <Field
                      autoComplete="off"
                      className="form-control"
                      placeholder="0"
                      name={
                        revisors_handling_2
                          .revisors_handling_2_alt_3_antal_bokonti_ikke_opprettet_i_boets_navn
                          .id
                      }
                    />
                  </div>
                </div>
                <div className="row align-items-center">
                  <div className="col-9">
                    <label>
                      {
                        revisors_handling_2
                          .revisors_handling_2_alt_3_antal_bokonti_ikke_separate
                          .label
                      }
                    </label>
                  </div>
                  <div className="col-3">
                    <Field
                      autoComplete="off"
                      className="form-control"
                      placeholder="0"
                      name={
                        revisors_handling_2
                          .revisors_handling_2_alt_3_antal_bokonti_ikke_separate
                          .id
                      }
                    />
                  </div>
                </div>
                <div className="mt-2">
                  <label className="mb-2">
                    {
                      revisors_handling_2.revisors_handling_2_alt_3_bemaerkning
                        .label
                    }{" "}
                    <span className="text-muted">
                      {
                        revisors_handling_2
                          .revisors_handling_2_alt_3_bemaerkning.sublabel
                      }
                    </span>
                    :
                  </label>
                  <ValidatedField
                    autoComplete="off"
                    as="textarea"
                    rows={2}
                    placeholder="Bemærkning"
                    name={
                      revisors_handling_2.revisors_handling_2_alt_3_bemaerkning
                        .id
                    }
                    touched={touched.revisors_handling_2_alt_3_bemaerkning}
                    error={errors.revisors_handling_2_alt_3_bemaerkning}
                  />
                </div>
              </div>
            </RadioCard>
          </div>
        </fieldset>
      </AccordionBody>
    </AccordionItem>
  );
}
